export const initializeStoreblocksAssets = (): void => {
  const links = ['fonts.css', 'phosphor.css', 'symbols.css', 'index.min.css'];

  links.forEach((href) => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `${window.config.storeblocksAssetsBaseUrl}/${href}`;
    document.head.appendChild(link);
  });
};
